// src/pages/ExamFinish.jsx
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function ExamFinish() {
    const { id } = useParams(); // attemptId
    const nav = useNavigate();

    return (
        <div style={{ maxWidth: 760, marginTop: 80, padding: '0 16px' }}>
            <div style={{
                display: 'grid', gap: 16, padding: 24, borderRadius: 16, border: '1px solid #e6e6e6',
                background: '#f8fffb', paddingBottom:30
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span
              aria-hidden
              style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: '#16a34a', color: '#fff', display: 'grid', placeItems: 'center',
                  fontWeight: 700
              }}
          >
            ✓
          </span>
                    <h1 style={{ margin: 0, fontSize: 22 }}>Odpowiedzi zostały przesłane</h1>
                </div>

                <p style={{ margin: 0, lineHeight: 1.6 }}>
                    Twoje odpowiedzi dla podejścia <b>#{id}</b> zostały zapisane i zamknięte.
                    Po weryfikacji i ocenie prowadzącego pojawią się tutaj szczegółowe informacje
                    (wynik, komentarze, ewentualne uwagi z proctoringu).
                </p>

                <div style={{ marginTop: 8, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button  className={'but-smal'}
                        onClick={() => nav('/student')}
                        style={{ background: '#fff', color:'#003671' }}
                    >
                        Przejdź do panelu studenta
                    </button>
                    <button  className={'but-smal'}
                        onClick={() => nav(`/student/egzamin/${id}/wyniki`)}
                    >
                        Zobacz odpowiedzi podejścia
                    </button>
                </div>


            </div>
        </div>
    );
}
